import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const VerifyPage: React.FC = () => {
  const [sp] = useSearchParams();
  const token = sp.get('token') || '';
  const { API_BASE_URL } = useAuth();
  const [status, setStatus] = useState<'idle' | 'ok' | 'fail' | 'working'>('idle');
  const [msg, setMsg] = useState<string>('');

  useEffect(() => {
    if (!token) {
      setStatus('fail');
      setMsg('Missing verification token.');
      return;
    }
    (async () => {
      try {
        setStatus('working');
        const res = await fetch(`${API_BASE_URL}/auth/verify-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ token }),
        });
        if (!res.ok) {
          const j = await res.json().catch(() => ({}));
          throw new Error(j?.error || 'Verification failed');
        }
        setStatus('ok');
        setMsg('Your email has been verified. You can now sign in.');
      } catch (e: any) {
        setStatus('fail');
        setMsg(e?.message || 'Verification failed.');
      }
    })();
  }, [API_BASE_URL, token]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-md px-6 pt-16">
        <header className="text-center">
          <img src="/logo-color.svg" alt="" aria-hidden="true" className="mx-auto h-8 w-auto" />
          <h1 className="mt-6 text-3xl font-extrabold tracking-tight text-gray-900">Verify your email</h1>
        </header>
        <main id="main" className="mt-8">
          <div className="rounded-2xl border border-gray-200 bg-white p-6 elev-1 text-center space-y-3">
            {status === 'working' && <p className="text-gray-600">Verifying…</p>}
            {status !== 'working' && <p className={status === 'ok' ? 'text-green-700' : 'text-red-700'}>{msg}</p>}
            <div>
              <Link to="/login" className="text-sedra hover:underline">Back to sign in</Link>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default VerifyPage; 